import clsx from 'clsx';
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import React, { useEffect, useState } from 'react';

import SvgCheckMark from '@components/Images/CheckMark';

import NavItemList from '../../TopNav/NavItemList';
import { SETTINGS_SUBNAV_MORE_NAV_ITEMS } from '../../navItems';
import SettingsSubmenuNavItem from './NavItem';

dayjs.extend(isSameOrAfter);

const DAYS_TO_SHOW_NEXT_STEP = 90;

type SettingsSubmenuNavFooterProps = {
  avatarUrl: string;
  profileCompletionPercentage: number;
  profileCompletionStatuses: { text: string; isComplete: boolean; href: string | null }[];
  username: string;
  initialSubscribeDateStr: string;
};

const Footer = ({
  initialSubscribeDateStr,
  profileCompletionPercentage,
  profileCompletionStatuses,
}: SettingsSubmenuNavFooterProps) => {
  const [showNextStep, setShowNextStep] = useState(false);

  useEffect(() => {
    setShowNextStep(
      initialSubscribeDateStr?.length > 0 &&
        dayjs()
          .subtract(DAYS_TO_SHOW_NEXT_STEP, 'days')
          .isSameOrAfter(dayjs(initialSubscribeDateStr))
    );
  }, [initialSubscribeDateStr]);

  return showNextStep ? (
    <NavItemList className="space-y-20">
      {SETTINGS_SUBNAV_MORE_NAV_ITEMS.map(({ name, ...rest }) => (
        <SettingsSubmenuNavItem
          className="opacity-50 hover:opacity-100 focus:opacity-100"
          as="link"
          key={name}
          {...rest}
        >
          {name}
        </SettingsSubmenuNavItem>
      ))}
    </NavItemList>
  ) : (
    <>
      <div className="flex justify-between font-suisse-screen text-[11px]/[1.3]">
        <span className="text-white">Complete your profile</span>
        <span className="text-primary-magenta">{profileCompletionPercentage}%</span>
      </div>
      <div className="mt-20 space-y-12">
        {profileCompletionStatuses.map((item) => {
          return (
            <a
              className={clsx(
                'flex items-center gap-4 font-suisse-screen text-[11px]/[1.3] text-white',
                {
                  'transition-colors hover:text-primary-magenta focus:text-primary-magenta dark:hover:text-primary-pink':
                    item.href,
                }
              )}
              href={item.href}
              key={item.text}
            >
              <SvgCheckMark
                className={clsx('w-20 flex-shrink-0', {
                  'text-grayscale-gray': !item.isComplete,
                  'text-primary-magenta': item.isComplete,
                })}
              />
              <span>{item.text}</span>
            </a>
          );
        })}
      </div>
    </>
  );
};

export default Footer;
